import { useQuery } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { applySignal } from "./applySignal";

export function useVisitBloodSamplesQuery(pointer: {
  patientId: string;
  visitId: string;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: ["visitBloodSamples", pointer.patientId, pointer.visitId],
    queryFn: ({ signal }) => {
      const req = api.bloodSample.getBloodSamplesFor(pointer);
      applySignal(req, signal);

      return req.result;
    },
  });
}
